module.exports = __webpack_public_path__ + "img/landScape.34e1333f.jpg";